import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import styles from "./logoList.module.scss";

export const PlanDetailLogoList = (props: Props): ReactElement => {
  return (
    <>
      {props.data.title && <p className={styles.title}>{props.data.title}</p>}
      {props.data.description && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: props.data.description }}
        ></div>
      )}
      {props.data.logos && (
        <div className={styles.logos}>
          {props.data.logos?.map((l, i) => (
            <img src={l.logo} key={`logo_${i}`} alt="" />
          ))}
        </div>
      )}
    </>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
